var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKorea = function SvgKorea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Korea_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Korea_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M100 190.909c50.207 0 90.909-40.702 90.909-90.909 0-50.208-40.702-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100c0 50.207 40.702 90.909 90.91 90.909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    fillRule: "evenodd",
    d: "m141.464 49.904 9.482 14.258-5.167 3.465-9.491-14.258zm11.221 16.855 9.518 14.258-5.193 3.43-9.5-14.232z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "m149.252 44.712-5.196 3.462 20.727 31.1 5.195-3.462-20.726-31.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    fillRule: "evenodd",
    d: "m157.008 39.536 9.509 14.284-5.192 3.43-9.5-14.258 5.183-3.456m11.227 16.881 9.491 14.25-5.175 3.464-9.492-14.258 5.176-3.456M43 115.553l20.727 31.07-5.184 3.464-20.719-31.079L43 115.553m-7.764 5.192 9.482 14.224-5.167 3.456-9.5-14.223 5.185-3.457m11.222 16.847 9.5 14.258-5.176 3.465-9.5-14.259 5.176-3.464m-18.991-11.663 20.71 31.079-5.175 3.465-20.728-31.078 5.193-3.466m10.357-44.911 20.72-31.114 5.183 3.465L43 84.448l-5.176-3.43",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "m50.778 44.722-20.726 31.1 5.18 3.454L55.96 48.175l-5.181-3.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    fillRule: "evenodd",
    d: "m22.275 70.667 20.727-31.131 5.176 3.456-20.71 31.14-5.193-3.465m114.013 75.956 9.491-14.216 5.167 3.457-9.482 14.223zm11.222-16.786 9.5-14.284 5.193 3.455-9.518 14.259zm-3.458 22.013 9.5-14.258 5.183 3.464-9.49 14.259zm11.231-16.881 9.508-14.224 5.184 3.457-9.5 14.223zm-3.458 22.039 9.5-14.233 5.192 3.44-9.509 14.258zm11.234-16.82 9.492-14.259 5.175 3.466-9.491 14.223z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC283D",
    fillRule: "evenodd",
    d: "M68.923 79.29c-.148.173-.278.39-.4.625.14-.235.252-.452.4-.625",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC283D",
    fillRule: "evenodd",
    d: "M120.747 68.913c-17.176-11.454-40.38-6.765-51.824 10.376-5.74 8.554-3.404 20.19 5.184 25.913 8.588 5.722 20.172 3.403 25.895-5.185 5.731-8.588 17.333-10.889 25.912-5.193 8.596 5.723 10.906 17.36 5.175 25.921 11.454-17.176 6.826-40.379-10.342-51.833",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293B78",
    fillRule: "evenodd",
    d: "M68.92 79.29c-5.739 8.562-3.403 20.19 5.185 25.912 8.588 5.722 20.172 3.403 25.895-5.185 5.731-8.588 17.332-10.889 25.912-5.192 8.596 5.722 10.906 17.358 5.175 25.92-11.436 17.211-34.63 21.831-51.815 10.377-17.16-11.454-21.805-34.657-10.351-51.832",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgKorea;